import { PublicClientApplication, Configuration, LogLevel, BrowserCacheLocation } from "@azure/msal-browser";
import { config } from "./config";

function getQualifiedUrl(uri: string): string {
  return new URL(uri, window.location.origin).href;
}

export function authProviderSetup(): PublicClientApplication {
  const msalConfig: Configuration = {
    auth: {
      clientId: config.get("clientId"),
      authority: `https://login.microsoftonline.com/${config.get("directoryId")}`,
      redirectUri: getQualifiedUrl("/"),
      postLogoutRedirectUri: getQualifiedUrl("/logout"),
      navigateToLoginRequestUrl: false, // Set back to false for SPA
      knownAuthorities: [],
      cloudDiscoveryMetadata: "",
      authorityMetadata: ""
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: false,
      secureCookies: false
    },
    system: {
      allowNativeBroker: false,
      windowHashTimeout: 60000,
      iframeHashTimeout: 6000,
      loadFrameTimeout: 0,
      asyncPopups: false, // Disable async popups for SPA
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
              console.info(message);
              return;
            case LogLevel.Verbose:
              console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
              return;
          }
        },
        logLevel: LogLevel.Verbose,
        piiLoggingEnabled: false
      },
    },
  };

  const msalInstance = new PublicClientApplication(msalConfig);

  // Initialize without handling redirect - let UserContext handle it
  const initialize = async () => {
    try {
      await msalInstance.initialize();
    } catch (error) {
      console.error("MSAL initialization error:", error);
    }
  };

  // Start initialization but don't handle redirect here
  initialize();

  return msalInstance;
}

export function getAuthProvider(envType: string): PublicClientApplication | null {
  return envType === "accessibility" || envType === "test" ? null : authProviderSetup();
}
